export default __webpack_public_path__ + "static/media/Logo-IHSAN.40c9212e.png";